
import { Link, useLocation } from "react-router-dom";

export default function StyleTileGrid({ styles }) {
  const { pathname } = useLocation(); // keeps URL base (we're on forged-monoblock)
  const base = pathname.replace(/\/$/, ""); // remove trailing /

  return (
    <section className="mt-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {styles.map((s) => (
          <Link
            key={s.id}
            to={`${base}/${s.slug}`}
            className="group bg-neutral-900 rounded-2xl overflow-hidden shadow-lg focus:outline-none focus:ring-2 focus:ring-white/40"
            data-style-id={s.id}
            data-style-name={s.name}
          >
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={s.img}
                alt={s.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                loading="lazy"
              />
            </div>
            <div className="p-4 text-white text-center">
              <h4 className="text-lg font-semibold">{s.name}</h4>
              <p className="text-xs opacity-70 mt-1">{s.blurb}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
